export class Constants {
    static readonly DATE_FMT = 'MM-dd-yy';
    static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
}